



/* dv-card-fixes appended 2026-07-23 (lives here rather than a new asset file so it
   reaches the live page via existing-file content update without waiting on the
   theme.liquid HTML cache to refresh - same route the CSS fixes took).
   1) moves each card's add-to-cart button out of the on-image action cluster into
      the info row next to the title (oh polly layout); CSS .dv-cart-in-title rules
      in dv-card-polish-v2.css style + grid-place it.
   2) swaps the header minicart's inline 15x16 bag svg for the new tote icon
      (the liquid snippet is fixed too, but that render is stuck behind the HTML
      cache - this patches the already-served markup). */
(function () {
  function relocate(card) {
    if (card.dataset.dvCartMoved) return;
    var cartBtn = card.querySelector(".product__add-cart");
    var infoBlock = card.parentNode ? card.parentNode.querySelector(".product-item__information") : null;
    if (!infoBlock && card.nextElementSibling && card.nextElementSibling.classList && card.nextElementSibling.classList.contains("product-item__information")) {
      infoBlock = card.nextElementSibling;
    }
    if (!cartBtn || !infoBlock) return;
    cartBtn.classList.add("dv-cart-in-title");
    infoBlock.insertBefore(cartBtn, infoBlock.firstChild);
    card.dataset.dvCartMoved = "1";
  }
  var TOTE = '<path d="M4.5 7.5h15L18 21H6L4.5 7.5Z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M9 10V5.75A2.75 2.75 0 0 1 11.75 3h.5A2.75 2.75 0 0 1 15 5.75V10" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>';
  function patchHeaderCart(root) {
    (root || document).querySelectorAll('h-count svg[viewBox="0 0 15 16"]').forEach(function (s) {
      s.setAttribute("viewBox", "0 0 24 24");
      s.setAttribute("width", "18");
      s.setAttribute("height", "18");
      s.innerHTML = TOTE;
    });
  }
  function scan(root) {
    (root || document).querySelectorAll(".product-item__inner").forEach(relocate);
    patchHeaderCart(root);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(); });
  } else {
    scan();
  }
  window.addEventListener("load", function () { scan(); });
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j].parentNode || document);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();


/* 2026-07-23: ARIA chat launcher (#ac-b) should lift above the PDP sticky
   add-to-cart bar when it is visible, and drop back to its normal bottom
   position when it is not (any other page, or before the sticky bar
   engages on scroll). IntersectionObserver on the real sticky-add-cart
   element rather than guessing its show/hide class name - this reacts to
   actual on-screen visibility regardless of how the theme toggles it. */
(function () {
  function init() {
    var chatBtn = document.getElementById("ac-b");
    var stickyBar = document.querySelector("sticky-add-cart");
    if (!chatBtn || !stickyBar || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0) {
          var h = stickyBar.offsetHeight || 70;
          chatBtn.style.setProperty("bottom", (h + 16) + "px", "important");
          chatBtn.style.setProperty("transition", "bottom .25s ease", "important");
        } else {
          chatBtn.style.removeProperty("bottom");
        }
      });
    }, { threshold: 0.01 });
    io.observe(stickyBar);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


/* 2026-07-23: cart-count badge visibility - only show on a non-empty bag
   (owner reference: oh polly shows a small dark circle with the number,
   nothing at all when the bag is empty). Reads the real rendered count
   text rather than a theme cart-update event name, so it works regardless
   of which AJAX-cart mechanism this theme fires. */
(function () {
  function sync() {
    document.querySelectorAll(".cart-count").forEach(function (el) {
      var text = (el.firstChild && el.firstChild.textContent || "").trim();
      var n = parseInt(text, 10);
      el.classList.toggle("dv-has-items", text === "~" || (!isNaN(n) && n > 0));
    });
  }
  sync();
  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true, characterData: true });
})();


/* 2026-07-23: measure the announcement bar's real rendered height so the
   sticky header (dv-card-polish CSS) can stack directly below it instead of
   overlapping at the same top:0. Re-measures on resize since the bar's
   text/height can change per breakpoint. */
(function () {
  function measure() {
    var bar = document.querySelector(".section-top-bar");
    var h = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty("--dv-topbar-h", h + "px");
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", measure);
  } else {
    measure();
  }
  window.addEventListener("load", measure);
  window.addEventListener("resize", measure);
})();


/* 2026-07-23 DEFINITIVE FIX: cart drawer / mobile nav still rendering behind
   the sticky header despite very high z-index overrides. Root cause: z-index
   only competes WITHIN a stacking context - if these elements are DOM
   descendants of the header (their trigger buttons live inside it), they
   can never escape its stacking context, no matter how high their own
   z-index is set, if a sibling (the announcement bar) paints above the
   header itself. Fix that sidesteps the whole problem: move these elements
   to be direct children of <body> at runtime, so they compete in the same
   top-level stacking context as the header - guaranteed correct regardless
   of where they started in the markup. appendChild preserves existing
   event listeners (nothing is cloned/recreated). */
(function () {
  function portalToBody(selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.parentElement !== document.body) {
        document.body.appendChild(el);
      }
    });
  }
  function run() {
    portalToBody(".popup_cart");
    portalToBody(".navigation.mobile");
    portalToBody(".navigation-mobile");
    portalToBody(".popup-search-form");
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  window.addEventListener("load", run);
})();
